/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Immature_OverloadInputs */

const en_coach_immature_overload = /** @type {(inputs: Coach_Immature_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your fitness metrics are still stabilizing (less than 4 weeks of data). Early readings suggest high fatigue relative to your short history. Consider an easy day, but keep in mind these numbers are preliminary.`)
};

const de_coach_immature_overload = /** @type {(inputs: Coach_Immature_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Werte pendeln sich noch ein — weniger als 4 Wochen Daten. Erste Signale zeigen hohe Ermüdung für deinen kurzen Verlauf. Mach ruhig einen lockeren Tag — aber bedenke, dass die Werte noch vorläufig sind.`)
};

/**
* | output |
* | --- |
* | "Your fitness metrics are still stabilizing (less than 4 weeks of data). Early readings suggest high fatigue relative to your short history. Consider an easy ..." |
*
* @param {Coach_Immature_OverloadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_immature_overload = /** @type {((inputs?: Coach_Immature_OverloadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Immature_OverloadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_immature_overload(inputs)
	return de_coach_immature_overload(inputs)
});